import Header from '@nankai/admin/layouts/Header';
import Sidebar from '@nankai/admin/layouts/Sidebar';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import styles from './base.module.css';

const BaseLayout: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.base}>
      <Header webTitle={t('common.title')} />
      <div className={styles.container}>
        <Sidebar />
        <main className={styles.main}>
          <div className={styles.inner}>
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default BaseLayout;
